import { gql, useQuery } from "@apollo/client";
import moment from "moment";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { PageLayout } from "src/components/shopify/PageLayout";
import { ContextUser } from "../../../../context/ContextUser";

const QUERY = gql`
  query massUploadList($offset: Int = 0, $limit: Int = 10, $supplierId: Int!) {
    massUploadList(offset: $offset, limit: $limit, supplierId: $supplierId) {
      id
      reference
      progress
      total
      status
      createdAt
    }
  }
`;

export function MassProductListScreen() {
  const context = useContext(ContextUser);
  const { data, loading, error } = useQuery(QUERY, {
    variables: {
      offset: 0,
      limit: 10000,
      supplierId: Number(context.merchant.id),
    },
    fetchPolicy: "no-cache",
  });

  // if (loading || data === undefined) {
  //   return (
  //     <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
  //       <div className="row">
  //         <div className="col-md-6">
  //           <SectionBlock title="Mass Upload List" transparent={true}>
  //             <Loading />
  //           </SectionBlock>
  //         </div>
  //       </div>
  //     </Content>
  //   );
  // }

  return (
    <PageLayout
      pageProp={{
        title: "Mass Upload List",
      }}
      loading={loading}
      error={error}
    >
      {data && (
        <div className="row">
          <div className="col-md-6">
            <Link to="/product/mass" className="btn btn-secondary btn-sm">
              Create Mass Upload Product
            </Link>
            <br />
            <br />
            <table className="table table-padded">
              <thead>
                <tr>
                  <th className="text-center">status</th>
                  <th className="text-center">total</th>
                  <th className="text-center">progress</th>
                  <th className="text-center">create date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.massUploadList.map((x: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td className="text-center">
                          <small>{x.status}</small>
                        </td>
                        <td className="text-center">{x.total}</td>
                        <td className="text-center">{x.progress ? x.progress : 0}</td>
                        <td className="text-center">{moment(new Date(x.createdAt)).format("YYYY-MM-DD HH:mm:ss")}</td>
                        <td className="text-center">
                          <Link className="btn btn-primary btn-sm" to={`/product/mass/detail/${x.id}`}>
                            Detail
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </PageLayout>
  );
}
